import React from 'react';
import {Icon, Select} from 'antd';
import {Link, useHistory, useLocation} from 'react-router-dom';


export default function MobileServiceNavigation({
                                                    instructionTitle,
                                                    supportTitle,
                                                    instructionItems,
                                                    instructionSelectorLabel,
                                                    allInstructionsTitle,
                                                    navigationAriaLabel
                                                }) {
    const history = useHistory();
    const location = useLocation();

    const isInstructionSection = (
        location.pathname === '/service/instruction' ||
        instructionItems.some(
            item => (
                location.pathname === item.link ||
                location.pathname.startsWith(
                    `${item.link}/`
                )
            )
        )
    );

    const isSupportSection = (
        location.pathname === '/service/support' ||
        location.pathname.startsWith(
            '/service/support/'
        )
    );

    const selectedInstruction = instructionItems.find(
        item => (
            location.pathname === item.link ||
            location.pathname.startsWith(
                `${item.link}/`
            )
        )
    );

    return (
        <nav
            className="service-mobile-navigation"
            aria-label={navigationAriaLabel}
        >
            <div className="service-mobile-navigation__sections">
                <Link
                    className={[
                        'service-mobile-navigation__section',
                        isInstructionSection
                            ? 'service-mobile-navigation__section--active'
                            : ''
                    ].filter(Boolean).join(' ')}
                    to="/service/instruction"
                >
                    <Icon type="read"/>

                    <span>
                        {instructionTitle}
                    </span>
                </Link>

                <Link
                    className={[
                        'service-mobile-navigation__section',
                        isSupportSection
                            ? 'service-mobile-navigation__section--active'
                            : ''
                    ].filter(Boolean).join(' ')}
                    to="/service/support"
                >
                    <Icon type="customer-service"/>

                    <span>
                        {supportTitle}
                    </span>
                </Link>
            </div>

            {isInstructionSection && (
                <div className="service-mobile-navigation__instructions">
                    <span className="service-mobile-navigation__label">
                        {instructionSelectorLabel}
                    </span>

                    <Select
                        className="service-mobile-navigation__select"
                        dropdownClassName="service-mobile-navigation__dropdown"
                        aria-label={instructionSelectorLabel}
                        value={
                            selectedInstruction
                                ? selectedInstruction.link
                                : '/service/instruction'
                        }
                        onChange={(value) => {
                            history.push(value);
                        }}
                        suffixIcon={
                            <Icon type="down"/>
                        }
                    >
                        <Select.Option value="/service/instruction">
                            {allInstructionsTitle}
                        </Select.Option>

                        {instructionItems.map((item) => (
                            <Select.Option
                                key={item.key}
                                value={item.link}
                            >
                                {item.sortTitle}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
            )}
        </nav>
    );
}
